import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module widget/widgetresize/sizeview
 */
import { View } from '@ckeditor/ckeditor5-ui';
/**
 * A view displaying the proposed new element size during the resizing.
 */
var SizeView = /*#__PURE__*/function (_View) {
  _inherits(SizeView, _View);
  var _super = _createSuper(SizeView);
  function SizeView() {
    var _this;
    _classCallCheck(this, SizeView);
    _this = _super.call(this);
    var bind = _this.bindTemplate;
    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-size-view', bind.to('_viewPosition', function (value) {
          return value ? "ck-orientation-".concat(value) : '';
        })],
        style: {
          display: bind.if('_isVisible', 'none', function (visible) {
            return !visible;
          })
        }
      },
      children: [{
        text: bind.to('_label')
      }]
    });
    return _this;
  }
  /**
   * A method used for binding the `SizeView` instance properties to the `ResizeState` instance observable properties.
   *
   * @internal
   * @param options An object defining the resizer options, used for setting the proper size label.
   * @param resizeState The `ResizeState` class instance, used for keeping the `SizeView` state up to date.
   */
  _createClass(SizeView, [{
    key: "_bindToState",
    value: function _bindToState(options, resizeState) {
      this.bind('_isVisible').to(resizeState, 'proposedWidth', resizeState, 'proposedHeight', function (width, height) {
        return width !== null && height !== null;
      });
      this.bind('_label').to(resizeState, 'proposedHandleHostWidth', resizeState, 'proposedHandleHostHeight', resizeState, 'proposedWidthPercents', function (width, height, widthPercents) {
        if (options.unit === 'px') {
          return "".concat(width, "\xD7").concat(height);
        } else {
          return "".concat(widthPercents, "%");
        }
      });
      this.bind('_viewPosition').to(resizeState, 'activeHandlePosition', resizeState, 'proposedHandleHostWidth', resizeState, 'proposedHandleHostHeight',
      // If the widget is too small to contain the size label, display the label above.
      function (position, width, height) {
        return width < 50 || height < 50 ? 'above-center' : position;
      });
    }
    /**
     * A method used for cleaning up. It removes the bindings and hides the view.
     *
     * @internal
     */
  }, {
    key: "_dismiss",
    value: function _dismiss() {
      this.unbind();
      this._isVisible = false;
    }
  }]);
  return SizeView;
}(View);
export { SizeView as default };